import React, { useCallback } from 'react'
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { StatusCard, StatusBox, StatusHeading } from './styles';
import { statusOptions } from './values';
import { ThumbDown, ThumbUp, Download } from '@mui/icons-material';
import RegularButton from 'components/CustomButtons/Button';
import { changePrePayrollStatus } from 'redux/actions/prePayroll/prePayrollActions';

export default function PrePayrollStatus(props) {
  const { periods, setPeriods } = props.periodsHandler
  const { token, rules } = useSelector(state => state.login)
  const dispatch = useDispatch()
  const { prePayrollsObj } = useSelector(state => state.prePayroll)
  const { status: statusPrePayroll } = prePayrollsObj
  const { status } = statusPrePayroll

  const getLoadedPrePayroll = useCallback(( token, statusData ) => {
    dispatch(changePrePayrollStatus( token, statusData ));
    setPeriods({
      ...periods, 
      [statusData.idContract]: [...periods[statusData.idContract].filter(period => period.id !== statusData.id), statusData]
    })
  }, [periods]);

  return (
    <StatusCard>                  
      <StatusBox status={status}>
          <StatusHeading>{`Estatus de pre-nomina: ${statusOptions[status]?.label}`}</StatusHeading>
          {
            rules.includes('PREPAYROLL-ADMIN') && <Box style={{marginRight: 12}}>
              <RegularButton 
                round 
                justIcon 
                color="success" 
                disabled={status !== 'CALCULATED'}
                style={{ margin: 2 }} 
                onClick={() => {getLoadedPrePayroll(token, {...statusPrePayroll, status: 'APPROVED'})}}
                tooltip="Aprobar"
              >
                <ThumbUp style={{ margin: 0 }}/>
              </RegularButton>
              <RegularButton 
                round 
                justIcon 
                color="danger" 
                disabled={status !== 'CALCULATED'}
                style={{ margin: 2 }} 
                onClick={() => {getLoadedPrePayroll(token, {...statusPrePayroll, status: 'REJECTED'})}}
                tooltip="Rechazar"
              >
                <ThumbDown style={{ margin: 0 }}/>
              </RegularButton>
              <RegularButton 
                round 
                justIcon 
                color="facebook" 
                disabled={status !== 'APPROVED'}
                style={{ margin: 2 }} 
                onClick={() => {getLoadedPrePayroll(token, {...statusPrePayroll, status: 'DOWNLOADED'})}}
                tooltip="Descargar"
              >
                <Download style={{ margin: 0 }}/>
              </RegularButton>
            </Box>
          }
      </StatusBox>
    </StatusCard>
  );
}
